(function(){
  var isCollection = window.location.pathname.includes('/collections/');
  var isSearch = window.location.pathname.includes('/search');
  var isProduct = window.location.pathname.includes('/products/');
  if(!isCollection && !isProduct && !isSearch) return;

  var CLIENT_ID = 'E1Wnl8TZSi';
  var STAR_COLOR = '#EBBF20';
  var EMPTY_COLOR = '#D8D8D8';
  var ratingsCache = {};
  var handleToId = {};

  function buildHandleMap() {
    try {
      var products = window.boostSDFallback.products || [];
      products.forEach(function(p) {
        if (p.handle && p.id) handleToId[p.handle] = String(p.id);
      });
    } catch(e) {}
  }

  function starSVG(fill) {
    return '<svg width="14" height="14" viewBox="0 0 24 24" style="vertical-align:middle;"><path fill="' + fill + '" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg>';
  }

  function renderStarsHTML(rating, raters) {
    var full = Math.floor(rating);
    var hasHalf = (rating - full) >= 0.25;
    var html = '<div style="display:inline-flex;align-items:center;gap:1px;flex-wrap:nowrap;">';
    for (var i = 0; i < 5; i++) {
      if (i < full) html += starSVG(STAR_COLOR);
      else if (i === full && hasHalf) {
        var uid = Math.random().toString(36).substr(2,4);
        html += '<svg width="14" height="14" viewBox="0 0 24 24" style="vertical-align:middle;"><defs><linearGradient id="rdwh' + uid + '"><stop offset="50%" stop-color="' + STAR_COLOR + '"/><stop offset="50%" stop-color="' + EMPTY_COLOR + '"/></linearGradient></defs><path fill="url(#rdwh' + uid + ')" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg>';
      } else html += starSVG(EMPTY_COLOR);
    }
    html += ' <span style="font-size:12px;color:#555;margin-left:3px;">(' + raters + ')</span></div>';
    return html;
  }

  function fetchRatings(ids, callback) {
    if (!ids.length) return;
    var hash = window.loox_global_hash || (window.LOOX && window.LOOX.hash) || '';
    if (!hash) { setTimeout(function(){ fetchRatings(ids, callback); }, 2000); return; }
    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'https://loox.io/widget/' + CLIENT_ID + '/ratings?products_ids=' + ids.join(',') + '&h=' + hash, true);
    xhr.onload = function() {
      try {
        var resp = JSON.parse(xhr.responseText);
        if (resp.success && Array.isArray(resp.ratings)) {
          resp.ratings.forEach(function(r) { ratingsCache[String(r.pid)] = { rating: r.rating, raters: r.raters }; });
          if (callback) callback();
        }
      } catch(e) {}
    };
    xhr.send();
  }

  /* === COLLECTION PAGES: Boost SD fallback + app rendered products === */
  function processBoostSD() {
    buildHandleMap();
    var links = document.querySelectorAll('a[href*="/products/"]:not([data-rdw-rated])');
    if (!links.length) return;

    var needFetch = [];
    links.forEach(function(link) {
      link.setAttribute('data-rdw-rated', '1');
      var m = (link.getAttribute('href') || '').match(/\/products\/([^?&#\/]+)/);
      if (!m) return;
      var pid = handleToId[m[1]];
      if (!pid) return;

      // Walk up to find product card
      var card = link;
      for (var i = 0; i < 6; i++) {
        if (!card.parentElement) break;
        card = card.parentElement;
        var cls = card.className || '';
        if (cls.indexOf('product') !== -1 || cls.indexOf('item') !== -1 || cls.indexOf('card') !== -1) break;
      }
      if (card.querySelector('[data-rdw-stars]')) return;

      var anchor = card.querySelector('.boost-sd__fallback-product-title, .boost-sd__product-title, h2, h3, h4') || link;
      var div = document.createElement('div');
      div.setAttribute('data-rdw-stars', pid);
      div.className = 'loox-rating';
      div.style.cssText = 'margin:4px 0 2px;min-height:18px;line-height:1;';
      anchor.insertAdjacentElement('afterend', div);

      if (ratingsCache[pid]) {
        div.innerHTML = renderStarsHTML(ratingsCache[pid].rating, ratingsCache[pid].raters);
      } else {
        needFetch.push(pid);
      }
    });

    if (needFetch.length > 0) {
      var unique = needFetch.filter(function(v,i,a){ return a.indexOf(v)===i; });
      fetchRatings(unique, function() {
        document.querySelectorAll('[data-rdw-stars]').forEach(function(el) {
          var pid = el.getAttribute('data-rdw-stars');
          var data = ratingsCache[pid];
          if (data && data.rating > 0 && !el.innerHTML.trim()) {
            el.innerHTML = renderStarsHTML(data.rating, data.raters);
          } else if (!data || data.rating <= 0) {
            el.style.visibility = 'hidden';
          }
        });
      });
    }
  }

  /* === ORIGINAL: .product-wrapper[data-id] for theme-rendered grids === */
  function injectLooxStars(scope) {
    var cards = scope.querySelectorAll('.product-wrapper[data-id]:not([data-rdw-rated])');
    cards.forEach(function(card) {
      card.setAttribute('data-rdw-rated', '1');
      var pid = card.getAttribute('data-id');
      if (!pid || card.querySelector('.loox-rating, .loox-reviews-default')) return;
      var nameEl = card.querySelector('.product-group-vendor-name') || card.querySelector('.product-name');
      if (!nameEl) return;
      var widget = document.createElement('div');
      widget.className = 'loox-rating';
      widget.setAttribute('data-id', pid);
      widget.setAttribute('data-fetch', '');
      var priceEl = card.querySelector('.product-price');
      if (priceEl) priceEl.parentNode.insertBefore(widget, priceEl);
      else nameEl.appendChild(widget);
    });
    try { if (window.loox && window.loox.init) window.loox.init(); } catch(e) {}
  }

  if (isCollection || isSearch) {
    var debounce = null;
    function runAll() {
      processBoostSD();
      injectLooxStars(document);
    }
    var observer = new MutationObserver(function() {
      clearTimeout(debounce);
      debounce = setTimeout(runAll, 400);
    });
    function start() {
      var target = document.querySelector('.main-content') || document.getElementById('MainContent') || document.body;
      observer.observe(target, { childList: true, subtree: true });
      [500, 1500, 3000, 5000, 8000, 12000, 20000].forEach(function(ms) { setTimeout(runAll, ms); });
      setTimeout(function() { observer.disconnect(); }, 30000);
    }
    document.addEventListener('boost-sd:product-list-rendered', runAll);
    document.addEventListener('boost-sd:page-rendered', runAll);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  }

  if (isProduct) {
    function tryRelatedInject() {
      var related = document.getElementById('related_item');
      if (related) injectLooxStars(related);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { setTimeout(tryRelatedInject, 1000); });
    else setTimeout(tryRelatedInject, 1000);
  }
})();
